import Hubx from "./HubX";
import AuthenticationService from "./services/AuthenticationService";
import UserService from "./services/UserService";
import CustomerService from "./services/CustomerService";
import InstallationService from "./services/InstallationService";
import BusinessEventService from "./services/BusinessEventService";
import InstallationLevelService from "./services/InstallationLevelService";
import TankLevelService from "./services/TankService";
import InstallationConsumptionService from "./services/InstallationConsumption";
import NotificationService from "./services/NotificationService";
import ExportFileService from "./services/ExportFileService";
import OrganizationService from "./services/OrganizationService";
import DirectorShipService from "./services/DirectorShipService";
import InstallationGroupService from "./services/InstallationGroupService";
import GroupService from "./services/GroupService";
import ClientService from "./services/ClientsService";
import DirectorService from "./services/DirectorService";
import RegionShipService from "./services/RegionShipService";

// Ordered alphabetically to facilitate maintenance
export const APPROVE_CHARGE = "APPROVE_CHARGE";
export const DELETE_GROUP = "DELETE_GROUP";
export const DELETE_INSTALLATION_GROUP = "DELETE_INSTALLATION_GROUP";
export const DO_LOGIN = "DO_LOGIN";
export const DO_NOTIFICATION_READED = "DO_NOTIFICATION_READED";
export const DO_RENEW_AUTH_TOKEN = "DO_RENEW_AUTH_TOKEN";
export const DO_RESET_AUTHENTICATION = "DO_RESET_AUTHENTICATION";
export const DO_RESET_PASSWORD = "DO_RESET_PASSWORD";
export const DO_RESET_TOKEN_VALIDATE = "DO_RESET_TOKEN_VALIDATE";
export const DO_SEARCH_INSTALLATION = "DO_SEARCH_INSTALLATION";
export const DO_SEND_RESET_PASSWORD = "DO_SEND_RESET_PASSWORD";
export const DO_UPDATE_PUSH_USER_TOKEN = "DO_UPDATE_PUSH_USER_TOKEN";
export const FETCH_ALL_CLIENTS = "FETCH_ALL_CLIENTS";
export const FETCH_ALL_CLIENTS_BY_FILTER = "FETCH_ALL_CLIENTS_BY_FILTER";
export const FETCH_ALL_INSTALLATIONS = "FETCH_ALL_INSTALLATIONS";
export const FETCH_BUSINESS_EVENTS = "FETCH_BUSINESS_EVENTS";
export const FETCH_BUSINESS_EVENT_BY_ID = "FETCH_BUSINESS_EVENT_BY_ID";
export const FETCH_CACHEABLE_CUSTOMERS = "FETCH_CACHEABLE_CUSTOMERS";
export const FETCH_CLIENTS = "FETCH_CLIENTS";
export const FETCH_CUSTOMERS = "FETCH_CUSTOMERS";
export const FETCH_DIRECTORIES = "FETCH_DIRECTORIES";
export const FETCH_DISTINCT_DIRECTORIES = "FETCH_DISTINCT_DIRECTORIES";
export const FETCH_DISTINCT_REGIONS = "FETCH_DISTINCT_REGIONS";
export const FETCH_EXCEL_FILE_CONSUMPTION_HISTORY = "FETCH_EXCEL_FILE_CONSUMPTION_HISTORY";
export const FETCH_EXCEL_FILE_LEVEL_HISTORY = "FETCH_EXCEL_FILE_LEVEL_HISTORY";
export const FETCH_GROUP = "FETCH_GROUP";
export const FETCH_GROUPS_LIST = "FETCH_GROUPS_LIST";
export const FETCH_INSTALLATION = "FETCH_INSTALLATION";
export const FETCH_INSTALLATION_CONSUMPTION = "FETCH_INSTALLATION_CONSUMPTION";
export const FETCH_INSTALLATION_GROUP = "FETCH_INSTALLATION_GROUP";
export const FETCH_INSTALLATION_GROUPS = "FETCH_INSTALLATION_GROUPS";
export const FETCH_INSTALLATION_LEVEL_READINGS = "FETCH_INSTALLATION_LEVEL_READINGS";
export const FETCH_MULTIPLE_INSTALLATIONS_CONSUMPTION = "FETCH_MULTIPLE_INSTALLATIONS_CONSUMPTION";
export const FETCH_NOTIFICATION_UNREAD = "FETCH_NOTIFICATION_UNREAD";
export const FETCH_ORGANIZATIONS = "FETCH_ORGANIZATIONS";
export const FETCH_PDF_FILE_FROM_HTML = "FETCH_PDF_FILE_FROM_HTML";
export const FETCH_TANKS_LEVEL_READINGS = "FETCH_TANKS_LEVEL_READINGS";
export const FETCH_TANKS_READINGS = "FETCH_TANKS_READINGS";
export const FETCH_USER_INFO = "FETCH_USER_INFO";
export const FILTER_CLIENTS = "FILTER_CLIENTS";
export const FILTER_USERS = "FILTER_USERS";
export const POST_GROUP = "POST_GROUP";
export const POST_INSTALLATION_GROUP = "POST_INSTALLATION_GROUP";
export const POST_INSTALLATION_TANKS_READINGS = "POST_INSTALLATION_TANKS_READINGS";
export const PUT_INSTALLATION_GROUP = "PUT_INSTALLATION_GROUP";
export const TEST_BEARER_TOKEN = "TEST_BEARER_TOKEN";
export const TEST_FEDX = "TEST_FEDX";
export const ALL_DIRECTORS = "ALL_DIRECTORS";
export const POST_USER_DIRECTOR = "POST_USER_DIRECTOR";

// A Mailbox is a collection of API calls under a commom "mailbox" name.
// This maps requests to MAILBOX_NAME to a set of API calls.
// Ordered alphabetically to facilitate maintenance
export default class Fedx {
  build(hubx: Hubx) {
    // FIXME:
    hubx.attachMediator(APPROVE_CHARGE, new BusinessEventService().approveCharge);
    hubx.attachMediator(DELETE_GROUP, new GroupService().delete);
    hubx.attachMediator(DELETE_INSTALLATION_GROUP, new InstallationGroupService().remove);
    hubx.attachMediator(DO_LOGIN, new AuthenticationService().doLogin);
    hubx.attachMediator(DO_NOTIFICATION_READED, new NotificationService().setNotificationReaded);
    hubx.attachMediator(DO_RENEW_AUTH_TOKEN, new AuthenticationService().renewToken);
    hubx.attachMediator(DO_RESET_AUTHENTICATION, new AuthenticationService().alterPassword);
    hubx.attachMediator(DO_RESET_PASSWORD, new UserService().resetPassword);
    hubx.attachMediator(DO_RESET_TOKEN_VALIDATE, new UserService().validateResetToken);
    hubx.attachMediator(DO_SEARCH_INSTALLATION, new InstallationService().search);
    hubx.attachMediator(DO_SEND_RESET_PASSWORD, new UserService().sendResetPassword);
    hubx.attachMediator(DO_UPDATE_PUSH_USER_TOKEN, new UserService().updatePushToken);
    hubx.attachMediator(FETCH_ALL_CLIENTS, new CustomerService().fetchClients);
    hubx.attachMediator(FETCH_ALL_CLIENTS_BY_FILTER, new CustomerService().fetchFilterClients);
    hubx.attachMediator(FETCH_ALL_INSTALLATIONS, new InstallationService().fetchAll);
    hubx.attachMediator(FETCH_BUSINESS_EVENTS, new BusinessEventService().fetchBusinessEvents);
    hubx.attachMediator(FETCH_BUSINESS_EVENT_BY_ID, new BusinessEventService().fetchById);
    hubx.attachMediator(FETCH_CACHEABLE_CUSTOMERS, new CustomerService().fetchAllCacheable);
    hubx.attachMediator(FETCH_CLIENTS, new ClientService().fetch);
    hubx.attachMediator(FETCH_CUSTOMERS, new CustomerService().fetchAll);
    hubx.attachMediator(FETCH_DIRECTORIES, new DirectorShipService().fetch);
    hubx.attachMediator(FETCH_DISTINCT_DIRECTORIES, new DirectorShipService().fetchDistinct);
    hubx.attachMediator(FETCH_DISTINCT_REGIONS, new RegionShipService().fetchDistinct);
    hubx.attachMediator(FETCH_EXCEL_FILE_CONSUMPTION_HISTORY, new ExportFileService().exportExcelConsumptionHistory);
    hubx.attachMediator(FETCH_EXCEL_FILE_LEVEL_HISTORY, new ExportFileService().exportExcelLevelHistory);
    hubx.attachMediator(FETCH_GROUP, new GroupService().fetch);
    hubx.attachMediator(FETCH_GROUPS_LIST, new GroupService().fetchAll);
    hubx.attachMediator(FETCH_INSTALLATION, new InstallationService().fetch);
    hubx.attachMediator(FETCH_INSTALLATION_CONSUMPTION, new InstallationConsumptionService().fetch);
    hubx.attachMediator(FETCH_INSTALLATION_GROUP, new InstallationGroupService().fetch);
    hubx.attachMediator(FETCH_INSTALLATION_GROUPS, new InstallationGroupService().fetchAll);
    hubx.attachMediator(FETCH_INSTALLATION_LEVEL_READINGS, new InstallationLevelService().fetch);
    hubx.attachMediator(FETCH_MULTIPLE_INSTALLATIONS_CONSUMPTION, new InstallationConsumptionService().fetchMultiple);
    hubx.attachMediator(FETCH_NOTIFICATION_UNREAD, new NotificationService().fetchUnRead);
    hubx.attachMediator(FETCH_ORGANIZATIONS, new OrganizationService().fetch);
    hubx.attachMediator(FETCH_PDF_FILE_FROM_HTML, new ExportFileService().exportPdfFromHtml);
    hubx.attachMediator(FETCH_TANKS_LEVEL_READINGS, new TankLevelService().fetch);
    hubx.attachMediator(FETCH_USER_INFO, new UserService().fetch);
    hubx.attachMediator(FILTER_CLIENTS, new ClientService().filter);
    hubx.attachMediator(FILTER_USERS, new UserService().filterUsers);
    hubx.attachMediator(POST_GROUP, new GroupService().post);
    hubx.attachMediator(POST_INSTALLATION_GROUP, new InstallationGroupService().create);
    hubx.attachMediator(POST_INSTALLATION_TANKS_READINGS, new InstallationLevelService().update);
    hubx.attachMediator(PUT_INSTALLATION_GROUP, new InstallationGroupService().update);
    hubx.attachMediator(TEST_BEARER_TOKEN, new AuthenticationService().testBearer);
    hubx.attachMediator(TEST_FEDX, _testFedx);
    hubx.attachMediator(ALL_DIRECTORS, new DirectorService().fetchAll);
    hubx.attachMediator(POST_USER_DIRECTOR, new DirectorService().save);
  }
}

async function _testFedx(): Promise<string> {
  //
  // eslint-disable-next-line no-console
  return new Promise((res) => {
    setTimeout(() => {
      res("ok!");
    }, 1000);
  });
}
